import request from './base'

export const accountList = (params) => {
    return request.post("/admin/v1/account/list", params)
}
export const accountAdd = (params) => {
    return request.post("/admin/v1/account/add", params)
}
export const accountModify = (params) => {
    return request.post("/admin/v1/account/modify", params)
}
export const accountDelete = (params) => {
    return request.post("/admin/v1/account/delete", params)
}
export const accountModifyPassword = (params) => {
    return request.post("/admin/v1/account/modify/password", params)
}
export const accountPermission = (params) => {
    return request.post("/admin/v1/account/permission", params)
}

//查询每个admin的权限
export const permissionOfAccounts= (params) => {
    return request.post("/admin/v1/account/permissionOfAccounts", params)
}

//删除权限
export const deletePerOfAccounts= (params) => {
    return request.post("/admin/v1/account/deletePerOfAccounts", params)
}

//添加权限
export const addPerOfAccounts= (params) => {
    return request.post("/admin/v1/account/addPerOfAccounts", params)
}

//添加权限种类
export const addCateOfPermission= (params) => {
    return request.post("/admin/v1/account/addCateOfPermission", params)
}

//删除权限种类
export const delCateOfAccounts= (params) => {
    return request.post("/admin/v1/account/delCateOfAccounts", params)
}




// WEBPACK FOOTER //
// ./src/api/account.js